import { ActivityEndUser, ScoredActivity } from 'modules/accountActivity/domain'

export const getEndUserDisplayInfo = (endUserData: ActivityEndUser | ScoredActivity) => {
  const endUserDisplayInfo = endUserData.name ?? endUserData.email

  if (!endUserDisplayInfo) {
    return endUserData.role ?? 'Site Visitor'
  }

  return endUserData.role ? `${endUserDisplayInfo} (${endUserData.role})` : `${endUserDisplayInfo}`
}
